import api from './index';
import { axios } from '@/utils/request';

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return axios({
    url: process.env.VUE_APP_CMS_SYSTEM + '/sys/login',
    method: 'post',
    data: parameter
  });
}
export function getLoginInfo() {
  return axios({
    url: process.env.VUE_APP_CMS_LOGIN + '/sso/getSSOCurrentUserInfo',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

export function phoneLogin(parameter) {
  return axios({
    url: process.env.VUE_APP_CMS_SYSTEM + '/sys/phoneLogin',
    method: 'post',
    data: parameter
  });
}

export function getSmsCaptcha(parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  });
}

export function getInfo() {
  return axios({
    url: process.env.VUE_APP_CMS_SYSTEM + '/api/user/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

export function logout(logoutToken) {
  return axios({
    url: process.env.VUE_APP_CMS_SYSTEM + '/sys/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Access-Token': logoutToken
    }
  });
}

/**
 * 第三方登录
 * @param token
 * @returns {*}
 */
export function thirdLogin(token) {
  return axios({
    url: process.env.VUE_APP_CMS_SYSTEM + `/thirdLogin/getLoginUser/${token}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}
